class Countdown extends HTMLElement {
  constructor() {
    super();

    this.countdownDate = this.getAttribute("data-countdown")
      ? new Date(this.getAttribute("data-countdown")).getTime()
      : null;
    this.days = this.querySelector(".days");
    this.hours = this.querySelector(".hours");
    this.mins = this.querySelector(".minutes");
    this.secs = this.querySelector(".seconds");
    this.element = this.getAttribute("data-element-to-hide");
    this.hideZero =
      this.getAttribute("data-hide-zero") == "true" ? true : false;

    if (
      this.countdownDate &&
      this.days &&
      this.hours &&
      this.mins &&
      this.secs
    ) {
      // Update the count down every 1 second
      const timer = setInterval(() => {
        // Get today's date and time
        const now = new Date().getTime();

        // Find the difference between now and the count down date
        const difference = this.countdownDate - now;

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const mins = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const secs = Math.floor((difference % (1000 * 60)) / 1000);

        // Time calculations for days, hours, minutes and seconds
        this.days.innerHTML = `${days > 0 ? days : 0} ${days == 1 ? window.countdownStrings.day : window.countdownStrings.days
          }`;

        if (days < 1 && this.hideZero) {
          this.days.classList.add("hidden");
        } else {
          this.days.classList.remove("hidden");
        }

        this.hours.innerHTML = `${hours > 0 ? hours : 0} ${hours == 1
          ? window.countdownStrings.hour
          : window.countdownStrings.hours
          }`;

        if (hours < 1 && this.hideZero) {
          this.hours.classList.add("hidden");
        } else {
          this.hours.classList.remove("hidden");
        }

        this.mins.innerHTML = `${mins > 0 ? mins : 0} ${mins == 1 ? window.countdownStrings.min : window.countdownStrings.mins
          }`;

        if (mins < 1 && this.hideZero) {
          this.mins.classList.add("hidden");
        } else {
          this.mins.classList.remove("hidden");
        }

        this.secs.innerHTML = `${secs > 0 ? secs : 0} ${window.countdownStrings.secs
          }`;

        // If the count down is finished, stop or show element
        if (difference > 0) {
          if (this.element) {
            this.showElement();
          }
        } else if (difference <= 0) {
          clearInterval(timer);
          if (this.element) {
            this.hideElement();
          }
        }
      }, 1000);
    }
  }

  showElement() {
    const elementById = document.querySelectorAll('#' + this.element);
    elementById.forEach((element) => {
      if (element) {
        element.classList.remove("hidden");
      }
    });
  }

  hideElement() {
    const elementById = document.querySelectorAll('#' + this.element);
    elementById.forEach((element) => {
      if (element) {
        element.classList.add("hidden");
        document.body.classList.add("announcement-hidden");
      }
    });
  }
}

customElements.define("countdown-timer", Countdown);
